import { useNavigate } from 'react-router';
import Icon from './Icon.jsx';
import styles from './PageHeader.module.scss';

export default function PageHeader({ title, subtitle, back, actions, children }) {
  const navigate = useNavigate();
  return (
    <header className={styles.header}>
      {back || actions ? (
        <div className={styles.bar}>
          {back ? (
            <button
              type="button"
              className={styles.back}
              onClick={() => (typeof back === 'string' ? navigate(back) : navigate(-1))}
            >
              <Icon name="back" size={22} stroke={2.4} />
              <span className="visually-hidden">Back</span>
            </button>
          ) : (
            <span />
          )}
          {actions ? <div className={styles.actions}>{actions}</div> : null}
        </div>
      ) : null}
      <div className={styles.titles}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      {children}
    </header>
  );
}
